/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
  external_date: ['external_date:lte', 'external_date:gte'],
  'external_customer_id': 'external_customer_id:in',
  'branch_id': 'branch_id:in',
  'integrated': 'integrated:is',
}

export default parseFilterDataMapping
